<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Create a New Good Return Voucher</h4>
                    <p class="text-subtitle-1">Good Return Voucher Creation Form</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <GoodReturnForm ref="form" v-model="data"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block color="primary" @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import GoodReturnForm from './../../../components/purchase/GoodReturnForm.vue';
import PAlert from './../../../components/common/PAlert';
import service from './../../../services/purchase/goodReturn';
import orderService from './../../../services/purchase/order';
import { v4 as uuid } from 'uuid'
import moment from 'moment';

export default {
    components: {
        GoodReturnForm,
        PAlert
    },
    data() {
        return {
            data: {},
            dataLoading: false,
            loading: false,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            idempotentKey: null,
            purchaseOrderID: null
        }
    },
    methods: {
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            service.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.replace({
                    name: "GoodReturnDisplay",
                    params: {
                        id: response.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = {...this.alert, content: "Are you sure you want to discard changes?", value: true, callback: this.cancel }
        },
        cancel() {
            this.$router.back();
        },
        fetchPurchaseOrder() {
            this.dataLoading = true;
            orderService.findByID(this.purchaseOrderID).then(response => {
                let d = response.data;
                this.data = {
                    code: "--",
                    date: moment().format("YYYY-MM-DD"),
                    purchase_order_code: d.code,
                    purchase_order_id: d.id,
                    warehouse_id: d.warehouse ? d.warehouse.id : null,
                    warehouse: d.warehouse,
                    lines: d.lines.map(line => {
                        return {
                            item: line.item,
                            item_id: line.item ? line.item.id : null,
                            measure_unit_id: line.measure_unit ? line.measure_unit.id : null,
                            quantity: line.net_received,
                            key: uuid()
                        }
                    })
                }
            }).finally(() => {
                this.dataLoading = false;
            })
        }
    },
    created() {
        this.idempotentKey = uuid();
        let orderID = this.$route.query.order_id;
        if(orderID) {
            this.purchaseOrderID = orderID
            this.fetchPurchaseOrder();
        }
    }
}
</script>

<style>

</style>